import { NgModule } from '@angular/core';
import { AlphanumericFilterDirective } from './input-formatters/alphanumeric-input-filter.directive';
import { AutoSelectDirective } from './input-formatters/auto-select.directive';
import { DecimalPrecision4FormatDirective } from './input-formatters/decimal-precision-4-input-format.directive';
import { DecimalPrecisionFormatDirective } from './input-formatters/decimal-precision-format.directive';
import { MaskDirective } from './mask/mask.directive';
import { IfDoesntHaveSecurityTransaction } from './security/if-doesnt-have-transaction.directive';
import { IfACSTransaction } from './security/if-has-ACS.directive';
import { IfHasBusinessUnit } from './security/if-has-business-unit.directive';
import { IfHasEnableDirective } from './security/if-has-enable.directive';
import { IfSecurityTransaction } from './security/if-has-transaction.directive';
import { IfLoggedIn } from './security/if-logged-in.directive';
import { SortKey } from './sort/sort-key.directive';
import { Sort } from './sort/sort.directive';
import { CommaMask } from './mask/comma-directive';
import { ThrottleClickDirective } from './throttle-click/throttle-click.directive';
import { InputTrimDirective } from './input-trim/input-trim.directive';
import { VirtualKeyboardDirective } from './virtual-keyboard/virtual-keyboard.directive';

@NgModule({
    declarations: [
        AlphanumericFilterDirective,
        AutoSelectDirective,
        DecimalPrecisionFormatDirective,
        DecimalPrecision4FormatDirective,
        IfACSTransaction,
        IfDoesntHaveSecurityTransaction,
        IfHasBusinessUnit,
        IfHasEnableDirective,
        IfLoggedIn,
        IfSecurityTransaction,
        MaskDirective,
        ThrottleClickDirective,
        Sort,
        SortKey,
        CommaMask,
        InputTrimDirective,
        VirtualKeyboardDirective
    ],
    exports: [
        AlphanumericFilterDirective,
        AutoSelectDirective,
        DecimalPrecisionFormatDirective,
        DecimalPrecision4FormatDirective,
        IfACSTransaction,
        IfDoesntHaveSecurityTransaction,
        IfHasBusinessUnit,
        IfHasEnableDirective,
        IfLoggedIn,
        IfSecurityTransaction,
        InputTrimDirective,
        ThrottleClickDirective,
        CommaMask,
        MaskDirective,
        Sort,
        SortKey,
        CommaMask,
        VirtualKeyboardDirective
    ]
})
export class SharedDirectivesModule {
}
